import React, {Component} from 'react';
import {optionRemoveAll, optionRemoved} from "../actions/OptionsActions";
import {withRouter} from "react-router-dom";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Tag from "@amzn/meridian/tag";
import Column from "@amzn/meridian/column";
import {connect} from "react-redux";
import Loader from "@amzn/meridian/loader";
import Link from "@amzn/meridian/link";
import {FormattedMessage} from "react-intl";
import {CONSTANT_FILTERS} from "../constants";
import {useDeviceLayout} from "./common/context/DeviceLayoutContext";
import {MobileDisplay} from "./common/MobileDisplay";
import FilterExpander from "./common/FilterExpander";

class Options extends Component {

    render() {
        const {loading, options, optionsTagsRequired, selectedOptions, isMobile} = this.props;

        const isFilterSet = () => {
            let isFilterSet = false;
            Object.keys(selectedOptions).filter((key) => !CONSTANT_FILTERS.includes(key))
                .forEach((key) => {
                    isFilterSet = isFilterSet || (selectedOptions[key] !== undefined && selectedOptions[key].length !== 0)
            })
            return isFilterSet
        }

        function showOptions() {
            if (loading) {
                return (
                    <Column
                        height="100px"
                        alignmentHorizontal="center"
                    >
                        <Loader/>
                    </Column>
                );
            }

            if(isMobile) {
                return (
                    <Box>
                        <FilterExpander>
                            <Column alignmentHorizontal="left" alignmentVertical="top" spacingInset="medium small" backgroundColor="secondary">
                                {options.map(option => {
                                        return (
                                            <Row heights="fill" alignmentHorizontal="center" spacingInset="none medium none" key={option.name}>
                                                {option.component}
                                            </Row>
                                        );
                                    }
                                )}
                            </Column>
                        </FilterExpander>
                    </Box>
                )
            }

            return (
                <Row alignmentHorizontal="left" alignmentVertical="top" spacingInset="medium large" backgroundColor="secondary">
                    {options.map(option => {
                            return (
                                <Column heights="fill" alignmentHorizontal="center" spacingInset="none medium none" key={option.name}>
                                    {option.component}
                                </Column>
                            );
                        }
                    )}
                </Row>
            )
        }

        const renderSelectedOptions = () => {
                return (
                    Object.keys(selectedOptions).filter(key => optionsTagsRequired.includes(key)).map(optionKey => {
                        const optionValues = selectedOptions[optionKey];
                        if (Array.isArray(optionValues)) {
                            return (
                                optionValues.filter(Boolean).map(optionValue => (
                                    <Tag type="theme" key={optionValue} onClose={() =>
                                        this.props.dispatch(optionRemoved(optionKey, optionValue))}>{optionValue}
                                    </Tag>)
                                ))
                        } else if(optionValues){
                            return <Tag key={optionValues} type="theme">
                                {optionValues}
                            </Tag>
                        } else {
                            return null;
                        }
                    }))
        }
        return (
            <Column width="100%" className="Options" spacingInset="none">
                {showOptions()}
                <MobileDisplay visibility={false}>
                    <Row widths={["grid-11"]} alignmentVertical="top" alignmenHorizontal="left">
                        <div className="options-tag">
                            {renderSelectedOptions()}
                            {isFilterSet() ? <Link onClick={() => this.props.dispatch(optionRemoveAll())} type="secondary">
                                <FormattedMessage id="clear_all" defaultMessage="Clear all"/>
                            </Link> : null}
                        </div>
                    </Row>
                </MobileDisplay>
            </Column>
        );
    }
}

// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent) {
    return function WrappedComponent(props) {
        const {isMobile} = useDeviceLayout();
        return <CustomComponent {...props} isMobile={isMobile}/>
    }
}

const mapStateToProps = state => ({
    loading: state.optionsReducer.loading,
    selectedOptions: state.optionsReducer.options,
    showingOptionsMenu: state.optionsReducer.showingOptionsMenu,
});
export default withRouter(connect(mapStateToProps)(classToFunctionAdapter(Options)));



// WEBPACK FOOTER //
// ./src/components/Options.js